
// オーナーズ　要素のクローンを挿入
$('.owner-intro .owner-first-body').before($('.owner-intro .owner-first-img').clone());
$('.owner-voice-year').next().before($('.owner-voice .owner-first-img').clone());
//スクロールに合わせてコンテンツを表示　trigger
	$('.inview,.inview-op').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
$(this).addClass('active');
			// if (visiblePartY == 'both') {
			// 	$(this).addClass('active');
			// }
		}
		else {
		}
	});
	$('.inview-screen').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).addClass('active');
			$(this).delay(700).queue(function() {
				$(this).addClass('out');
			});
		}
		else {
		}
	});

	// $(function() {
	// 	//1.7秒後にクラス付与
	// 	$('.top-mv-txt').delay(1700).queue(function(next) {
	// 	    $(this).addClass('active');
	// 	    next();
	// 	});
	//
	// });
